export const SITE_URL = "https://savvystephanie.com";
export const SHARE_IMAGE_URL = `${SITE_URL}/api/share-image.png`;

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

/**
 * Sets the document title, meta description and the social-sharing tags for the current route.
 * `share` (optional) is the owner-editable site.share object; when given, its title/description
 * are used for the Open Graph / Twitter card instead of the page title/description.
 */
export function setPageMeta(title, description, { path = window.location.pathname, share } = {}) {
  const url = `${SITE_URL}${path === "/" ? "/" : path.replace(/\/$/, "")}`;
  const ogTitle = share?.title || title;
  const ogDescription = share?.description || description;
  const image = share?.image ? (share.image.startsWith("http") ? share.image : `${SITE_URL}${share.image}`) : SHARE_IMAGE_URL;

  document.title = title;
  upsert('meta[name="description"]', { name: "description", content: description });
  upsert('link[rel="canonical"]', { rel: "canonical", href: url });
  upsert('meta[property="og:url"]', { property: "og:url", content: url });
  upsert('meta[property="og:title"]', { property: "og:title", content: ogTitle });
  upsert('meta[property="og:description"]', { property: "og:description", content: ogDescription });
  upsert('meta[property="og:image"]', { property: "og:image", content: image });
  upsert('meta[property="og:image:secure_url"]', { property: "og:image:secure_url", content: image });
  upsert('meta[name="twitter:title"]', { name: "twitter:title", content: ogTitle });
  upsert('meta[name="twitter:description"]', { name: "twitter:description", content: ogDescription });
  upsert('meta[name="twitter:image"]', { name: "twitter:image", content: image });
}
